import 'jquery';
import '../utils/easypiechart.js';
document.addEventListener('DOMContentLoaded', function (e) {

    var element = document.querySelector('.hv2-rating .hv2-rating__chart');
    var isVisible = false;

    function isElementInViewport(elem) {
        return elem.getBoundingClientRect().top < window.innerHeight;
    }

    function handleScroll() {
        if (isElementInViewport(element) && !isVisible) {
            isVisible = true;
            updateRating();
        }
    }
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    function updateRating(){
        jQuery('.hv2-rating .hv2-rating__chart').easyPieChart({
            size: 100,
            barColor: function (percent) {
                var barColor = '#767676';
                if (jQuery(this.el).data('barcolor')) {
                    barColor = jQuery(this.el).data('barcolor');
                }
                return barColor;
            },

            scaleLength: 0,
            lineWidth: 5,
            trackColor: '#C4C4C4',
            lineCap: 'butt',
            animate: 2000
        });
        jQuery('.hv2-rating .hv2-rating__counter').each(function () {
            var $this = jQuery(this),
                countTo = $this.attr('data-counter');

            jQuery({ countNum: $this.text() }).animate(
                {
                    countNum: countTo
                },
                {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $this.text(Math.floor(now));
                    },
                    complete: function () {
                        $this.text(this.countNum.toFixed(1));
                    }
                }
            );
        });
    }
});
